<template>
  <!-- 行业诚信公约 -->
  <div class="box index-less">
    <details-head img="./img/bj3.png" title="行业诚信公约" remarks="Convention" />
    <TopBreadcrumb :data="[{ label: '规划协会' }, { label: '行业诚信公约' }]" />
    <div class="con">
      <!-- <TopTab/> -->
      <div class="box">

        <div class="left">
          <Left title="行业诚信公约" remarks="Industry Integrity Convention"/>
        </div>
        <Right title="行业诚信公约" context="讲诚实，守信用，作为中国的传统文化一直被社会所认同和遵守。作为以技术和知识服务于社会的勘察设计行业，讲科学、讲诚信更是行业的立业之本。勘察设计工作是城市建设和工程建设的先导，做好勘察设计工作必须坚持科学发展观、坚持诚信服务的宗旨。" />
      </div>
    </div>
  </div>
</template>

<script>
import DetailsHead from "../../components/DetailsHead.vue";
import TopBreadcrumb from "../../components/TopBreadcrumb.vue";
import Left from "./comp/Left.vue";
import Right from "./comp/Right.vue";
import TopTab from "./comp/TopTab.vue";
import RightItem from "./comp/RightItem.vue";
import './comp/index.less'
export default {
  name: "Home",
  components: { DetailsHead, TopBreadcrumb, Left, Right,TopTab, RightItem },
  data() {
    return {};
  },
  methods: {},
};
</script>
 
<style lang="less" scoped>
.con .box .right {
  display: flex;
  flex-direction: column;
  gap: 13px;
}
</style>